import { render } from "./Inbox.vue?vue&type=template&id=d0ec9b0e&scoped=true"
import script from "./Inbox.vue?vue&type=script&lang=js"
export * from "./Inbox.vue?vue&type=script&lang=js"

import "./Inbox.vue?vue&type=style&index=0&id=d0ec9b0e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0ec9b0e"]])

export default __exports__